import { format } from 'date-fns';
import { enUS, id } from 'date-fns/locale';

export const convertDate = function (date) {
  const time = new Date(date?.getTime());
  time?.setHours(0, 0, 0, 0);
  return time?.toISOString();
};

export function dateFormated(date: Date, locale?: string) {
  return format(date, 'dd MMMM yyyy', {
    locale: locale === 'id' ? id : enUS,
  });
}

export function rangeDate(month: number = 1) {
  const today = new Date();
  const afterAtDate = today.getTime() - 1000 * 60 * 60 * 24 * 30 * month;
  const beforeAtDate = today.getTime();
  return {
    today,
    atAfter: new Date(afterAtDate),
    atBefore: new Date(beforeAtDate),
  };
}

export function sliceDateString(date: Date | string) {
  if (typeof date === 'string') {
    return date.slice(0, 10);
  }
  return date.toISOString().slice(0, 10);
}

export function toISOString(date: Date) {
  return format(date, 'yyyy-MM-dd');
}
